import { Eye, Heart, MessageCircle, Bookmark } from 'lucide-react';
import { cn } from '@/lib/cn';
import type { EngagementSnapshot } from '@/types/engagement';

interface EngagementStatsProps {
  snapshot: EngagementSnapshot;
  className?: string;
}

function fmt(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
}

export function EngagementStats({ snapshot, className }: EngagementStatsProps) {
  return (
    <div className={cn('flex items-center gap-3 text-sm text-muted-foreground', className)}>
      <span className="flex items-center gap-1">
        <Eye className="h-3.5 w-3.5" />
        {fmt(snapshot.views)}
      </span>
      <span className="flex items-center gap-1">
        <Heart className="h-3.5 w-3.5" />
        {fmt(snapshot.likes)}
      </span>
      <span className="flex items-center gap-1">
        <MessageCircle className="h-3.5 w-3.5" />
        {fmt(snapshot.comments)}
      </span>
      {snapshot.saves > 0 && (
        <span className="flex items-center gap-1">
          <Bookmark className="h-3.5 w-3.5" />
          {fmt(snapshot.saves)}
        </span>
      )}
    </div>
  );
}
